import React from 'react'

import ConditionPage from './ConditionPage'
import ConditionSvgs from './ConditionSvgs'
import { HistoryPageNumber, ImageCapturePageNumber } from '../../constants'

export default ({ prospectDocuments, exteriorDoorCount, urlState, ...props }) => {
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Vehicle Condition')
  const title = conditionQuestions && conditionQuestions[0] ? conditionQuestions[0].section : 'n/a'
  const svgItems = ['DriverSide' + exteriorDoorCount, 'Rear', 'PassengerSide' + exteriorDoorCount, 'FrontWithGrille']
  const { backClick } = props
  const backStep = urlState && !!urlState.edit ? HistoryPageNumber : ImageCapturePageNumber
  return (
    <ConditionPage {...{ title, conditionQuestions, svgItems, urlState, ...props }} pageName={'exterior'} noDamage={''} backClick={e => backClick(backStep)}>
      <ConditionSvgs svgItems={svgItems} width={400} height={150} addMolding={true} conditionQuestions={conditionQuestions} {...{ ...props }} />
    </ConditionPage>
  )
}
